export const environment = {
  production: false,
  baseUrl: 'https://cxportal.cxconnect.com/',
  baseUrlLogin: 'http://localhost:5000/api/Auth/AuthLogin',
};